import store from '@/store'
import config from '@/config'
import lodash from 'lodash'
import BoNavigationContext from '@/components/mixins/BoNavigationContext'

export default {
  mixins: [
    BoNavigationContext
  ],

  data () {
    return {
      periodicalRecommendedEventsTimeoutId: undefined,
      recommendedEventsBoNodeObject: {
        idfwbonavigation: 'recommended',
        displaytemplatename: config.app.autoconf.PLAYER_PERSONALISATION.eventGroupingForRecommendedEvents
      },
      periodicalTrendingEventsTimeoutId: undefined,
      trendingEventsBoNodeObject: {
        idfwbonavigation: 'trending',
        displaytemplatename: config.app.autoconf.PLAYER_PERSONALISATION.eventGroupingForRecommendedEvents
      },
      selectedTabId: null
    }
  },

  computed: {
    isRootSportsNavigation () {
      return this.$route.name === 'sports'
    },
    recommendedEventsMarketGroup () {
      return store.getters['vaixTabsState/getRecommendedEventsMarketGroup']
    },
    recommendedEventsMarketGroupsBySport () {
      return this.vaixTabsEventsMarketGroupsBySport(this.recommendedEventsMarketGroup)
    },
    trendingEventsMarketGroupsBySport () {
      return this.vaixTabsEventsMarketGroupsBySport(this.trendingEventsMarketGroup)
    },
    fallbackEventsMarketGroup () {
      if (!this.currentTabContainerBoNode) return null

      const firstNonLiveTabBoNode = this.currentTabContainerBoNode.bonavigationnodes.find(node =>
        !node.idfwbonavigationtypes.includes('INPLAYPERSPORTTYPE') &&
        Array.isArray(node.marketgroups) &&
        node.marketgroups.length > 0
      )

      if (!firstNonLiveTabBoNode || !Array.isArray(firstNonLiveTabBoNode.marketgroups)) return null

      const fallbackMGs = []
      let shouldShowLoading = false

      firstNonLiveTabBoNode.marketgroups.forEach(mg => {
        const id = mg.idfwmarketgroup
        const marketgroup = this.marketgroups[id]

        if (!marketgroup) {
          shouldShowLoading = true
          store.dispatch('marketgroupState/fetchMarketgroupById', id)
        } else {
          fallbackMGs.push({
            marketGroup: {
              events: marketgroup.events,
              idfwmarketgroup: marketgroup.idfwmarketgroup,
              marketgroupname: marketgroup.marketgroupname,
              idfwpopulationtype: marketgroup.idfwpopulationtype
            },
            name: marketgroup.marketgroupname
          })
        }
      })

      if (shouldShowLoading) {
        store.commit('vaixTabsState/setRecommendedEventsLoading', true)
        setTimeout(() => {
          store.commit('vaixTabsState/setRecommendedEventsLoading', false)
        }, 500)
      }

      return fallbackMGs.length > 0 ? fallbackMGs : null
    },
    recommendedEventsAvailablePrematchSports () {
      return this.vaixTabsEventsAvailablePrematchSports(this.recommendedEventsMarketGroup)
    },
    trendingEventsAvailablePrematchSports () {
      return this.vaixTabsEventsAvailablePrematchSports(this.trendingEventsMarketGroup)
    },
    resetTimeoutIntervalOnLogin () {
      return store.getters['vaixTabsState/getResetTimeoutIntervalOnLogin']
    },
    isRecommendedEventsOnSportPageEnabled () {
      return config.app.autoconf.PLAYER_PERSONALISATION.showRecommendedEventsOnSportsPage
    },
    recommendedCompetitionIds () {
      const tabContainer =
        this.currentBoNavigation &&
        Array.isArray(this.currentBoNavigation.bonavigationnodes) &&
        this.currentBoNavigation.bonavigationnodes.find(node =>
          Array.isArray(node.idfwbonavigationtypes) &&
          node.idfwbonavigationtypes.includes('TABCONTAINER')
        )

      if (!tabContainer) return []

      if (!Array.isArray(tabContainer.competitions) || !tabContainer.competitions.length) {
        return []
      }

      return [...new Set(tabContainer.competitions.filter(Boolean))]
    },
    isTrendingEventsOnSportPageEnabled () {
      return config.app.autoconf.PLAYER_PERSONALISATION.showTrendingEventsOnSportsPage
    },
    trendingEventsMarketGroup () {
      return store.getters['vaixTabsState/getTrendingEventsMarketGroup']
    },
    isTrendingEventsLoading () {
      return store.getters['vaixTabsState/getTrendingEventsLoading']
    },
    vaixTabs () {
      const configuredOrder = config.app.autoconf.PLAYER_PERSONALISATION.vaixTabs

      if (!Array.isArray(configuredOrder)) return []

      const allowedTabs = ['recommended', 'trending']

      return [...new Set(configuredOrder.filter(tab => allowedTabs.includes(tab)))]
    },
    visibleVaixTabs () {
      return this.vaixTabs.filter(tabId => {
        if (this.isRootSportsNavigation) {
          return this.isVaixTabVisible(tabId)
        }

        return this.isVaixTabVisibleOnSportsPage(tabId)
      })
    },
    isRecommendedEnabled () {
      return this.vaixTabs.includes('recommended')
    },
    isTrendingEnabled () {
      return this.vaixTabs.includes('trending')
    },
    isRecommendedEventsVisibleOnSportPage () {
      return this.isVaixEventsVisibleOnSportPage(
        this.isRecommendedEnabled,
        this.isRecommendedEventsOnSportPageEnabled
      )
    },
    isTrendingEventsVisibleOnSportPage () {
      return this.isVaixEventsVisibleOnSportPage(
        this.isTrendingEnabled,
        this.isTrendingEventsOnSportPageEnabled
      )
    },
    isRecommendedEventsVisible () {
      return this.isVaixEventsVisible(this.isRecommendedEnabled)
    },
    isTrendingEventsVisible () {
      return this.isVaixEventsVisible(this.isTrendingEnabled)
    },
    periodicalUpdateVaixEvents () {
      return config.app.autoconf.PLAYER_PERSONALISATION.periodicalUpdateVaixEvents || 60000
    }
  },

  methods: {
    isVaixTabVisible (vaixTabId) {
      if (vaixTabId === 'recommended') return this.isRecommendedEventsVisible
      if (vaixTabId === 'trending') return this.isTrendingEventsVisible
      return false
    },
    isVaixTabVisibleOnSportsPage (vaixTabId) {
      if (vaixTabId === 'recommended') return this.isRecommendedEventsVisibleOnSportPage
      if (vaixTabId === 'trending') return this.isTrendingEventsVisibleOnSportPage
      return false
    },
    startRecommendedEventsUpdate () {
      const isRootSportsNavigation = this.isRootSportsNavigation
      const isRecommendedEventsOnSportPageEnabled = this.isRecommendedEventsOnSportPageEnabled

      const hasCompetitionIds =
        isRecommendedEventsOnSportPageEnabled &&
        !isRootSportsNavigation &&
        Array.isArray(this.recommendedCompetitionIds) &&
        this.recommendedCompetitionIds.length > 0

      const hasSportTypeId =
        isRecommendedEventsOnSportPageEnabled &&
        !isRootSportsNavigation &&
        !!this.sportTypeId

      const shouldFetch =
        isRootSportsNavigation || hasCompetitionIds || hasSportTypeId

      if (!shouldFetch) return

      const userId =
        localStorage.customer && localStorage.customer !== 'undefined'
          ? localStorage.customer
          : null

      store
        .dispatch('vaixTabsState/fetchRecommendedEvents', {
          userId,
          competitionId: hasCompetitionIds ? this.recommendedCompetitionIds : null,
          sportTypeId: hasSportTypeId ? this.sportTypeId : null
        })
        .then(() => {
          clearTimeout(this.periodicalRecommendedEventsTimeoutId)

          this.periodicalRecommendedEventsTimeoutId = setTimeout(() => {
            this.startRecommendedEventsUpdate()
          }, config.app.autoconf.PLAYER_PERSONALISATION.periodicalUpdateVaixEvents)
        })
    },
    stopRecommendedEventsUpdate () {
      // console.log('RECOMM - Stop RecommendedEvents Update')
      clearTimeout(this.periodicalRecommendedEventsTimeoutId)
    },
    marketGroupNameBySport (event) {
      if (!event) return ''
      if (event.sportname && event.sportname.indexOf(event.fosporttypename) < 0) return `${event.fosporttypename} - ${event.sportname}`
      return event.sportname
    },
    startTrendingEventsUpdate () {
      const isRootSportsNavigation = this.isRootSportsNavigation
      const isTrendingEventsOnSportPageEnabled = this.isTrendingEventsOnSportPageEnabled

      const hasCompetitionIds =
        isTrendingEventsOnSportPageEnabled &&
        !isRootSportsNavigation &&
        Array.isArray(this.recommendedCompetitionIds) &&
        this.recommendedCompetitionIds.length > 0

      const hasSportTypeId =
        isTrendingEventsOnSportPageEnabled &&
        !isRootSportsNavigation &&
        !!this.sportTypeId

      const shouldFetch =
        isRootSportsNavigation || hasCompetitionIds || hasSportTypeId

      if (!shouldFetch) return

      const userId =
        localStorage.customer && localStorage.customer !== 'undefined'
          ? localStorage.customer
          : null

      store
        .dispatch('vaixTabsState/fetchTrendingEvents', {
          userId,
          competitionId: hasCompetitionIds ? this.recommendedCompetitionIds : null,
          sportTypeId: hasSportTypeId ? this.sportTypeId : null
        })
        .then(() => {
          clearTimeout(this.periodicalTrendingEventsTimeoutId)

          this.periodicalTrendingEventsTimeoutId = setTimeout(() => {
            this.startTrendingEventsUpdate()
          }, config.app.autoconf.PLAYER_PERSONALISATION.periodicalUpdateVaixEvents)
        })
    },
    stopTrendingEventsUpdate () {
      clearTimeout(this.periodicalTrendingEventsTimeoutId)
    },
    vaixTabsEventsAvailablePrematchSports (eventsMarketGroup) {
      const sports = []

      const addUniqueSport = (id, name) => {
        if (id && name && !sports.some(sp => sp.idfosporttype === id)) {
          sports.push({
            idfosporttype: id,
            fosporttypename: name
          })
        }
      }

      if (eventsMarketGroup && Array.isArray(eventsMarketGroup.events) && eventsMarketGroup.events.length) {
        eventsMarketGroup.events.forEach(ev => {
          addUniqueSport(ev.idfosporttype, ev.fosporttypename)
        })
      } else if (Array.isArray(this.fallbackEventsMarketGroup)) {
        this.fallbackEventsMarketGroup.forEach(group => {
          if (group.marketGroup && Array.isArray(group.marketGroup.events)) {
            group.marketGroup.events.forEach(ev => {
              addUniqueSport(ev.idfosporttype, ev.fosporttypename)
            })
          }
        })
      }

      return sports
    },
    vaixTabsEventsMarketGroupsBySport (eventsMarketGroup) {
      const marketGroups = []
      const events = eventsMarketGroup && Array.isArray(eventsMarketGroup.events)
        ? eventsMarketGroup.events
        : []

      const eventsBySport = lodash.groupBy(events, 'idfosporttype')

      Object.keys(eventsBySport).forEach(key => {
        marketGroups.push({
          name: key,
          marketGroup: {
            marketgroupname: eventsBySport[key][0] && eventsBySport[key][0].fosporttypename
              ? eventsBySport[key][0].fosporttypename
              : key,
            idfwmarketgroup: eventsMarketGroup.idfwmarketgroup || null,
            events: eventsBySport[key],
            idfwpopulationtype: 'NEXTOFFBYSPORTTYPEMKTTYPCLASSPER'
          }
        })
      })

      return marketGroups
    },
    isVaixEventsVisibleOnSportPage (isEnabled, isEnabledOnSportPage) {
      const hasCompetitionIds =
        Array.isArray(this.recommendedCompetitionIds) && this.recommendedCompetitionIds.length > 0

      const hasSportTypeId = !!this.sportTypeId

      return isEnabled &&
        isEnabledOnSportPage &&
        !this.isRootSportsNavigation &&
        (hasCompetitionIds || hasSportTypeId)
    },
    isVaixEventsVisible (isEnabled) {
      return isEnabled &&
        this.currentTabContainerBoNode &&
        this.currentTabContainerBoNode.firstTabContainer
    }
  },

  destroyed () {
    this.stopRecommendedEventsUpdate()
    this.stopTrendingEventsUpdate()
  },
  watch: {
    resetTimeoutIntervalOnLogin (newVal) {
      if (newVal) {
        this.stopRecommendedEventsUpdate()
        this.stopTrendingEventsUpdate()

        if (this.selectedTab && this.selectedTab.idfwbonavigation === 'recommended' && this.isRecommendedEnabled) {
          this.startRecommendedEventsUpdate()
        }

        if (this.selectedTab && this.selectedTab.idfwbonavigation === 'trending' && this.isTrendingEnabled) {
          this.startTrendingEventsUpdate()
        }
      }
    },

    selectedTab: {
      handler (newTab) {
        if (!newTab) return
        this.selectedTabId = newTab.idfwbonavigation
      },
      immediate: true
    },
    selectedTabId: {
      handler (id) {
        if (!id) return

        // STOP oba
        this.stopRecommendedEventsUpdate()
        this.stopTrendingEventsUpdate()

        // START samo aktivni
        if (id === 'recommended' && this.isRecommendedEnabled) {
          this.startRecommendedEventsUpdate()
        }

        if (id === 'trending' && this.isTrendingEnabled) {
          this.startTrendingEventsUpdate()
        }
      },
      immediate: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/VaixTabs.js